
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Icon from 'vux/src/components/icon/index.vue'


export default {
name: "station-info",
components: {
Flexbox, FlexboxItem, Tab,
TabItem, Swiper, SwiperItem, Popup, Icon
},
directives: {
TransferDom
},
props: ["info"],
data() {
return {
data: "",
popupHeader: {
name: ""
},
index: 0,
popupStatus: {
parking: false, //停车场
gas: false, //加气站
petrol: false,//加油站
chargePile: false, //充电桩
repair: false 
},
popupContent: {
parkingRemark: "",
petrol:0 ,//0上行 1下行
gas:0,
chargePileRemark:"",
repairRemark:""
},
tabView: {
up: true,
down: false
}
}
},
methods: {
/**
* 显示停车场详情
* @param direction  方向 0 上行 1 下行
*/
showPopupParking: function (direction) {
if (direction == 0) {
if(this.info.upParkingOpen==1){
this.popupStatus.parking = true;
this.popupContent.parkingRemark = this.info.upParkingRemark;
}
} else if (direction == 1) {
if(this.info.downParkingOpen==1){
this.popupStatus.parking = true;
this.popupContent.parkingRemark = this.info.downParkingRemark;
}
}
},

showChargePile: function (direction) {
if (direction == 0) {
this.popupStatus.chargePile = true;
if(this.info.upChargingpileOpen==1){
this.popupContent.chargePileRemark = this.info.upChargingpileRemark;
}
} else if (direction == 1) {
if(this.info.downChargingpileOpen==1){
this.popupStatus.chargePile = true;
this.popupContent.chargePileRemark = this.info.downChargingpileRemark;
}

}
},

showRepair: function (direction) {
if (direction == 0) {
if(this.info.upRepairOpen==1){
this.popupStatus.repair = true;
this.popupContent.repairRemark = this.info.upRepairRemark;
}
} else if (direction == 1) {
if(this.info.downRepairOpen==1){
this.popupStatus.repair = true;
this.popupContent.repairRemark = this.info.downRepairRemark;
}
}
},
/**
* 显示加油站详情
* @param direction
*/
showPopupPetrol: function (direction) {
if(direction==0){
if(this.info.upPetrolOpen==1){
this.popupStatus.petrol = true;
this.popupContent.petrol=direction;
}
}else if(direction==1){
if(this.info.downPetrolOpen==1){
this.popupStatus.petrol = true;
this.popupContent.petrol=direction;
}
}
},

/**
* 显示加气站详情
* @param direction
*/
showPopupGas: function (direction) {
if(direction==0){
if(this.info.upGasOpen==1){
this.popupStatus.gas = true;
this.popupContent.gas=direction;
}
}else if(direction==1){
if(this.info.downGasOpen==1){
this.popupStatus.gas = true;
this.popupContent.gas=direction;
}
}
}
},
mounted() {
this.$nextTick(() => {
console.warn(this.info);
});
}
}



// WEBPACK FOOTER //
// ./src/components/ServiceAreaInfo.vue